<template>
    <div class="employee-status-graph">
        <div class="graph-header locale-font">
            <div class="graph-title">
                {{ $vuetify.lang.t('$vuetify.employeeStatusGraph.title') }}
            </div>
            <div class="graph-sub-title">
                {{ $vuetify.lang.t('$vuetify.employeeStatusGraph.weekly') }}
            </div>
        </div>

        <bar-chart
            v-if="show"
            :options="options"
            :chart-data="chartData"
        ></bar-chart>
    </div>
</template>

<script>
import BarChart from '@/components/Chart/BarChart.js'
export default {
    name: 'EmployeeStatusGraph',

    components: {
        BarChart
    },

    computed: {
        days () {
            return [
                this.$vuetify.lang.t('$vuetify.employeeStatusGraph.mon'),
                this.$vuetify.lang.t('$vuetify.employeeStatusGraph.tue'),
                this.$vuetify.lang.t('$vuetify.employeeStatusGraph.wed'),
                this.$vuetify.lang.t('$vuetify.employeeStatusGraph.thu'),
                this.$vuetify.lang.t('$vuetify.employeeStatusGraph.fri'),
                this.$vuetify.lang.t('$vuetify.employeeStatusGraph.sat'),
                this.$vuetify.lang.t('$vuetify.employeeStatusGraph.sun')
            ]
        },
        chartData () {
            return this.init()
        }
    },

    data () {
        return {
            show: false,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            min: 0
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            fontSize: 14,
                            beginAtZero: true,
                            stepSize: 10
                        }
                    }]
                }
            },
            presentData: [],
            lateData: []
        }
    },

    methods: {
        async getData (totalEmployee = null) {
            this.show = false
            const res = await this.axios.get('dashboard/employee-status-graph')
            if (res && res.data && res.data.status === 'ok') {
                this.presentData = res.data.data.presentData
                this.lateData = res.data.data.lateData

                const suggestedScale = this.getSuggestedScale(totalEmployee)
                if (totalEmployee && suggestedScale) {
                    this.options.scales.yAxes[0].ticks.stepSize = suggestedScale.stepSize
                    this.options.scales.yAxes[0].ticks.suggestedMax = suggestedScale.suggestedMax
                }
                this.show = true
            }
        },

        getSuggestedScale (totalEmployee) {
            let minTotal = Number.MAX_VALUE
            for (let i = 0; i < this.presentData.length; i++) {
                const total = this.presentData[i] + this.lateData[i]
                if ((minTotal > total) && (total !== 0)) {
                    minTotal = total
                }
            }

            if ((minTotal < 100) && (minTotal !== Number.MAX_VALUE)) {
                return null
            }

            return { stepSize: 200, suggestedMax: Math.floor((totalEmployee / 1000) + 1) * 1000 }
        },

        init () {
            this.show = true
            return {
                labels: this.days,
                datasets: [
                    {
                        label: this.$vuetify.lang.t('$vuetify.attendanceSummaryList.present'),
                        backgroundColor: '#ead2ac',
                        borderColor: '#ead2ac',
                        fill: false,
                        data: this.presentData,

                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    type: 'string'
                                }]
                            }
                        }
                    },
                    {
                        label: this.$vuetify.lang.t('$vuetify.attendanceSummaryList.late'),
                        backgroundColor: '#d76436',
                        borderColor: '#d76436',
                        fill: false,
                        data: this.lateData,

                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    type: 'string'
                                }]
                            }
                        }
                    }
                ]
            }
        }
    },

    mounted () {
        this.init()
    }
}
</script>

<style lang="scss" scoped>
.employee-status-graph {
    border-radius: 15px;
    box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    padding: 15px;
}
.graph-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    .graph-title {
        font-size: 24px;
    }

    .graph-sub-title {
        font-size: 14px;
    }
}
</style>
